import React, {FC} from 'react';
import styled from 'styled-components';

import {
  SettingsSearchDropdownContent,
  SettingsSearchDropdownItem,
  SettingsSearchDropdownItemLeftIcon,
  SettingsSearchDropdownSubtitle,
  SettingsSearchDropdownTitle,
} from './settingsSearchCommon';
import {SettingsSearchDropdownItemBaseProps} from './settingsSearchCommonTypes';

/*
 * Props.
 */

interface SettingsSearchDropdownImportItemProps extends SettingsSearchDropdownItemBaseProps {
  itemKey: string;
  description: string;
  title: string;
}

/*
 * Style.
 */

const StyledIconDiv = styled.div<{$logo: string}>`
  width: 32px;
  height: 32px;

  background-image: url(${(p) => p.$logo});
  background-size: 32px;
  background-position: center;
  background-repeat: no-repeat;

  border-radius: 16px;
  width: 32px;
  height: 32px;
  box-sizing: border-box;
  background-color: transparent;
  border: 1px ${(p) => p.theme.alphas.gray10} solid;
`;

/*
 * Component.
 */

export const SettingsSearchDropdownImportItem: FC<SettingsSearchDropdownImportItemProps> = (props) => {
  const iconKeyMap: {[k: string]: string} = {
    zendeskImport: 'zendesk',
    helpScoutImport: 'helpscout',
    freshdeskImport: 'freshdesk',
    office365Import: 'office365',
  };
  const iconKey = iconKeyMap[props.itemKey];

  return (
    <SettingsSearchDropdownItem checkmarkLabel={props.title} onSelect={props.onSelect}>
      <SettingsSearchDropdownItemLeftIcon>
        <StyledIconDiv $logo={`/api/1/integration_types/${iconKey}/public/icons/card.svg`} />
      </SettingsSearchDropdownItemLeftIcon>
      <SettingsSearchDropdownContent>
        <SettingsSearchDropdownTitle>{props.title}</SettingsSearchDropdownTitle>
        <SettingsSearchDropdownSubtitle>{props.description}</SettingsSearchDropdownSubtitle>
      </SettingsSearchDropdownContent>
    </SettingsSearchDropdownItem>
  );
};
